import { render, staticRenderFns } from "./IpoSelector.vue?vue&type=template&id=646b4a2e"
import script from "./IpoSelector.vue?vue&type=script&lang=js"
export * from "./IpoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports